document.addEventListener('DOMContentLoaded', function(){

  // Real countdown, target date comes from data-target on #cs1107-countdown (ISO string set via section schema)
  (function(){
    var wrap = document.getElementById('cs1107-countdown');
    if(!wrap) return;
    var target = new Date(wrap.dataset.target || Date.now());
    var last = {};
    function setNum(id, val){
      var el = document.getElementById(id);
      if(!el || last[id] === val) return;
      last[id] = val;
      el.textContent = val;
      el.classList.remove('tick'); void el.offsetWidth; el.classList.add('tick');
    }
    function tick(){
      var now = new Date();
      var diff = Math.max(0, target - now);
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var pad = function(n){ return String(n).padStart(2,'0'); };
      setNum('cs1107-cd-days', pad(d));
      setNum('cs1107-cd-hours', pad(h));
      setNum('cs1107-cd-min', pad(m));
      setNum('cs1107-cd-sec', pad(s));
    }
    tick();
    setInterval(tick, 1000);
  })();

  // Scroll reveal (fade + mask-wipe variants)
  (function(){
    var items = document.querySelectorAll('.cs1107 .reveal, .cs1107 .reveal-mask');
    if(!items.length) return;
    if(!('IntersectionObserver' in window)){ items.forEach(function(el){ el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){ entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.15 });
    items.forEach(function(el){ io.observe(el); });
  })();

  // Magnetic buttons — subtle pull toward cursor, desktop hover only
  (function(){
    if(!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.cs1107 .magnetic').forEach(function(el){
      el.addEventListener('mousemove', function(e){
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width/2) * 0.25;
        var y = (e.clientY - r.top - r.height/2) * 0.35;
        el.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      el.addEventListener('mouseleave', function(){ el.style.transform = ''; });
    });
  })();

  // Subtle tilt on product cards, desktop hover only
  (function(){
    if(!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.cs1107 .bag-card').forEach(function(el){
      el.addEventListener('mousemove', function(e){
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(800px) rotateY(' + (px*4) + 'deg) rotateX(' + (-py*4) + 'deg) translateY(-4px)';
      });
      el.addEventListener('mouseleave', function(){ el.style.transform = ''; });
    });
  })();

  // Mobile nav drawer
  (function(){
    var openBtn = document.getElementById('cs1107-menu-open');
    var closeBtn = document.getElementById('cs1107-menu-close');
    var drawer = document.getElementById('cs1107-mobile-nav');
    var scrim = document.getElementById('cs1107-mobile-nav-scrim');
    if(!openBtn || !drawer || !scrim) return;
    function open(){
      drawer.classList.add('open'); scrim.classList.add('open');
      openBtn.setAttribute('aria-expanded','true');
      document.body.style.overflow = 'hidden';
    }
    function close(){
      drawer.classList.remove('open'); scrim.classList.remove('open');
      openBtn.setAttribute('aria-expanded','false');
      document.body.style.overflow = '';
    }
    openBtn.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    scrim.addEventListener('click', close);
    drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', close); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
  })();

  // Hero video — skip autoplay on data-saver / slow connections to protect mobile data.
  (function(){
    var video = document.getElementById('cs1107-hero-video');
    var playBtn = document.getElementById('cs1107-hero-video-play');
    var source = video ? video.querySelector('source[data-src]') : null;
    if(!video || !source || !playBtn) return;

    var conn = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
    var isConstrained = conn && (conn.saveData || /2g/.test(conn.effectiveType || ''));
    var wrap = video.closest('.cs1107');

    function loadAndPlay(){
      if(!source.dataset.src) return;
      video.src = source.dataset.src;
      video.setAttribute('preload', 'auto');
      video.setAttribute('autoplay', '');
      video.load();
      video.play().catch(function(){});
      if(wrap) wrap.classList.remove('save-data');
    }

    if(isConstrained){
      if(wrap) wrap.classList.add('save-data');
      playBtn.addEventListener('click', loadAndPlay);
    } else {
      loadAndPlay();
    }
  })();

  // Sticky mobile CTA — shows once hero is scrolled past
  (function(){
    var hero = document.getElementById('cs1107-hero');
    var bar = document.getElementById('cs1107-sticky-cta');
    if(!hero || !bar) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        bar.classList.toggle('show', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(hero);
  })();

});
